import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { Application } from '../../../models/admin-models';
import { AdminService } from '../../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-data-dictionary',
  templateUrl: './data-dictionary.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [
    MatSelectModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class DataDictionaryComponent implements OnInit {
  private admnSrvc = inject(AdminService);
  private snacky = inject(MatSnackBar);

  @Input() applications: Application[];
  @Output() toggleLoading = new EventEmitter();
  dataDictionary = {
    solution: null,
    firm: null,
    group: null,
    uiConfig: null,
  };
  unitsControl = new FormControl();
  filteredUnits;
  selectedUnit;

  ngOnInit(): void {
    this.getUnits();
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id.toLowerCase() === this.unitsControl.value.toLowerCase();
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  autoCompleteUnitChanged(ev) {
    this.unitsControl.setValue(ev.option.value);
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSrvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  getDataDictionary() {
    this.toggleLoading.emit();
    this.admnSrvc.getDataDictionary(this.dataDictionary).subscribe({
      next: resp => {
        let fileData;
        const filename = `${this.dataDictionary.solution}-${this.dataDictionary.firm}-${this.dataDictionary.group}-DataDictionary.csv`;
        const reader = new FileReader();
        reader.readAsDataURL(resp.body);

        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename);
        };
        this.toggleLoading.emit();
      },
      error: () => {
        this.snacky.open(
          `Oops! Something went wrong, please check your parameters and try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
        this.toggleLoading.emit();
      },
    });
  }
}
